import createRougeTheme from './createRougeTheme';
import default_rouge_theme from './default.rouge';
import monokai_rouge_theme from './monokai.rouge';
const registered_rouge_themes = {
    default: createRougeTheme('default', default_rouge_theme),
    monokai: createRougeTheme('monokai', monokai_rouge_theme),
};
export default registered_rouge_themes;
